export default {
    zh: {
      timeR: '倒计时: ',
      ruleText:'规则',
      DailyBenefits:'每日福利',
      rule:'1. 仅收集以上所示礼物（超出此范围的任何礼物将不计算在内。）</br>2.所有礼物将自动分配给前3名用户。如果您符合条件并且您还没有收到礼物。请联系我们。</br>3. 本次活动所有徽章有效期为一整年。</br>4. 头奖者，请联系我们索取特别礼物。</br>5.本次活动将于7月11日晚上结束。</br>6、App对此活动拥有最终权利。Apple 不是赞助商，也不是以任何形式参与此次活动。',
      content:'宰牲节的时间到了。</br>为了庆祝宰牲节</br>前 3 名用户将获得稀有而独特的奖牌。</br>房间也会收到礼物。</br>只有以下礼物将被计算在内：',
      mission:'任务',
      ranking:'排行',
      individual:'个人',
      room:'房间',
      rewards:'奖励',
      amount:'完成额度',
      collect:'收集',
      copyright:'本活动版权归App所有',
      collected:'收到',
      specialgift:'special background gift',
    },
    en: { 
      timeR: 'Count down: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:'1. Only the above shown gifts will be collected (any gifts outside of this range will not be counted.)</br>2. All gifts will be automatically distributed to top 3 users.If you have met the criteria and you have not receive the gifts. Please contact us.</br>3. All badges of this event will last for an entire year. </br>4. For the top winner, please contact us for your special gift. </br>5.This event will end on July 11th KSA time.</br>6. App has the final right to this activity. Apple is not a sponsor, nor participate in the event in any form.',
      content:'It is time for Eid al-Adha.  </br>To celebrate Eid al-Adha date, </br>Rare and unique medals will be given to top 3 users.</br>Rooms will also receive gifts.</br>Only the following gifts will be counted:',
      mission:'mission',
      ranking:'ranking',
      individual:'individual',
      room:'room',
      rewards:'rewards',
      amount:'Amount accomplished',
      collect:'collect',
      copyright:'The copyright of this activity belongs to App',
      collected:'received',
      specialgift:'special background gift',
    },
    ar: {
      timeR: 'العد التنازلي ',
      ruleText:'قواعد',
      DailyBenefits:'المكافأة اليومية',
      rule:'1. سيتم جمع الهدايا الموضحة أعلاه فقط (لن يتم احتساب أي هدايا خارج هذا النطاق.)</br>2. سيتم توزيع جميع الهدايا تلقائيًا على أعلى 3 مستخدمين.إذا كنت قد استوفيت المعايير ولم تستلم الهدايا. الرجاء التواصل معنا.</br>3. تستمر جميع شارات هذا الحدث لمدة عام كامل.</br>4. للفائز الأول ، يرجى الاتصال بنا للحصول على هديتك الخاصة.</br>5- سينتهي هذا الحدث في 11 يوليو بتوقيت المملكة العربية السعودية.</br>6. لدى App الحق النهائي في هذا النشاط.آبل ليست راعية ولا تشارك في الحدث بأي شكل من الأشكال.',
      content:'حان وقت عيد الأضحى.</br>للاحتفال بعيد الأضحى المبارك ،</br>سيتم منح ميداليات نادرة وفريدة من نوعها لأفضل 3 مستخدمين.</br>ستحصل الغرف أيضًا على هدايا.</br>سيتم احتساب الهدايا التالية فقط:',
      mission:'بعثة',
      ranking:'تصنيف',
      individual:'فرد',
      room:'مجال',
      rewards:'المكافآت',
      amount:'المبلغ المنجز',
      collect:'يجمع',
      copyright:'حقوق الطبع والنشر لهذا النشاط تعود إلى App',
      collected:'استلم',
      specialgift:'هدية خلفية خاصة',
    },
    tr: {
      timeR: 'Kalan süre: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:'1. Only the above shown gifts will be collected (any gifts outside of this range will not be counted.)</br>2. All gifts will be automatically distributed to top 3 users.If you have met the criteria and you have not receive the gifts. Please contact us.</br>3. All badges of this event will last for an entire year. </br>4. For the top winner, please contact us for your special gift. </br>5.This event will end on July 11th KSA time.</br>6. App has the final right to this activity. Apple is not a sponsor, nor participate in the event in any form.',
      content:'Kurban Bayramı vakti geldi.</br>Kurban Bayramı tarihini kutlamak için,</br>İlk 3 kullanıcıya nadir ve benzersiz madalyalar verilecek.</br>Odalara ayrıca hediyeler verilecektir.</br>Yalnızca aşağıdaki hediyeler sayılacaktır:',
      mission:'misyon',
      ranking:'sıralama',
      individual:'bireysel',
      room:'oda',
      rewards:'ödüller',
      amount:'Tamamlanan miktar',
      collect:'toplamak',
      copyright:"Bu etkinliğin telif hakkı App'ye aittir.",
      collected:'alındı',
      specialgift:'özel arka plan hediyesi',
    },
    jp: {
      timeR: 'カウントダウン: ',
      ruleText:'Rule',
      DailyBenefits:'Daily Benefits',
      rule:'1. Only the above shown gifts will be collected (any gifts outside of this range will not be counted.)</br>2. All gifts will be automatically distributed to top 3 users.If you have met the criteria and you have not receive the gifts. Please contact us.</br>3. All badges of this event will last for an entire year. </br>4. For the top winner, please contact us for your special gift. </br>5.This event will end on July 11th KSA time.</br>6. App has the final right to this activity. Apple is not a sponsor, nor participate in the event in any form.',
      content:'イード・アル＝アドハーの時間です。</br>イードアルアドハーの日付を祝うために、</br>珍しいユニークなメダルが上位3人のユーザーに贈られます。</br>客室にもギフトが贈られます。</br>次のギフトのみがカウントされます。',
      mission:'ミッション',
      ranking:'ランキング',
      individual:'個人',
      room:'部屋',
      rewards:'報酬',
      amount:'達成量',
      collect:'収集',
      copyright:'この活動の著作権はAppに帰属します',
      collected:'受信',
      specialgift:'特別な背景ギフト',
    },
    pt:{
        timeR: 'Contagem regressiva: ',
        ruleText: 'Regra',
        DailyBenefits: 'Benefícios Diários',
        rule: '1. Somente os presentes mostrados acima serão coletados (quaisquer presentes fora deste intervalo não serão contados.)</br>2. Todos os presentes serão automaticamente distribuídos aos 3 principais usuários. Se você atendeu aos critérios e não recebeu os presentes, entre em contato conosco.</br>3. Todos os distintivos deste evento durarão por um ano inteiro.</br>4. Para o vencedor principal, entre em contato conosco para o seu presente especial.</br>5. Este evento terminará em 11 de julho, horário KSA.</br>6. O aplicativo tem o direito final sobre esta atividade. O Apple não é patrocinador nem participa do evento de nenhuma forma.',
        content: 'É hora do Eid al-Adha. </br>Para comemorar a data do Eid al-Adha, </br>medalhas raras e únicas serão dadas aos 3 principais usuários.</br>As salas também receberão presentes.</br>Somente os seguintes presentes serão contados:',
        mission: 'missão',
        ranking: 'ranking',
        individual: 'individual',
        room: 'sala',
        rewards: 'recompensas',
        amount: 'Quantidade realizada',
        collect: 'coletar',
        copyright: 'Os direitos autorais desta atividade pertencem ao App',
        collected: 'recebido',
        specialgift: 'presente especial de fundo'

    },
    id:{
        timeR: 'Hitung mundur: ',
        ruleText: 'Aturan',
        DailyBenefits: 'Manfaat Harian',
        rule: '1. Hanya hadiah yang ditunjukkan di atas yang akan dikumpulkan (hadiah di luar rentang ini tidak akan dihitung.)</br>2. Semua hadiah akan didistribusikan secara otomatis ke 3 pengguna teratas. Jika Anda sudah memenuhi kriteria dan belum menerima hadiah, harap hubungi kami.</br>3. Semua lencana acara ini akan bertahan selama satu tahun penuh.</br>4. Untuk pemenang utama, harap hubungi kami untuk hadiah khusus Anda.</br>5. Acara ini akan berakhir pada 11 Juli waktu KSA.</br>6. Aplikasi memiliki hak final atas aktivitas ini. Apple bukan sponsor, dan tidak berpartisipasi dalam acara ini dalam bentuk apapun.',
        content: 'Saatnya untuk Eid al-Adha. </br>Untuk merayakan tanggal Eid al-Adha, </br>medali langka dan unik akan diberikan kepada 3 pengguna teratas.</br>Ruangan juga akan menerima hadiah.</br>Hanya hadiah berikut yang akan dihitung:',
        mission: 'misi',
        ranking: 'peringkat',
        individual: 'individual',
        room: 'ruang',
        rewards: 'hadiah',
        amount: 'Jumlah yang tercapai',
        collect: 'kumpulkan',
        copyright: 'Hak cipta dari aktivitas ini adalah milik Aplikasi',
        collected: 'diterima',
        specialgift: 'hadiah latar belakang khusus'

    },
    uz:{
        timeR: 'Taqvimni kamaytirish: ',
        ruleText: 'Qoidalar',
        DailyBenefits: 'Kundalik Foyda',
        rule: '1. Faqat yuqorida ko\'rsatilgan sovg\'alar yig\'iladi (bu doiradan tashqaridagi sovg\'alar hisobga olinmaydi.)</br>2. Barcha sovg\'alar avtomatik ravishda eng yaxshi 3 foydalanuvchiga taqsimlanadi. Agar siz mezonlarga javob bersangiz va sovg\'alarni olmagan bo\'lsangiz, iltimos biz bilan bog\'laning.</br>3. Ushbu tadbirning barcha badjlari butun yil davomida amal qiladi.</br>4. Eng yaxshi g\'olib uchun, iltimos biz bilan bog\'laning va maxsus sovg\'angizni oling.</br>5. Ushbu tadbir 11 iyul kuni KSA vaqti bilan yakunlanadi.</br>6. Ilova ushbu faoliyatda yakuniy huquqqa ega. Apple tadbirda homiy sifatida qatnashmaydi va har qanday shaklda ishtirok etmaydi.',
        content: 'Eid al-Adha vaqti keldi. </br>Eid al-Adha sana bayramini nishonlash uchun, </br>eng yaxshi 3 foydalanuvchiga noyob va kamdan-kam medallar taqdim etiladi.</br>Xonalar ham sovg\'alar olishadi.</br>Faqat quyidagi sovg\'alar hisobga olinadi:',
        mission: 'missiya',
        ranking: 'reyting',
        individual: 'shaxsiy',
        room: 'xona',
        rewards: 'sovg\'alar',
        amount: 'Yig\'ilgan miqdor',
        collect: 'yig\'ish',
        copyright: 'Ushbu faoliyatning mualliflik huquqi ilovaga tegishli',
        collected: 'olindi',
        specialgift: 'maxsus fon sovg\'asi'

    },

    ru:{
        timeR: 'Обратный отсчет: ',
        ruleText: 'Правила',
        DailyBenefits: 'Ежедневные выгоды',
        rule: '1. Будут собраны только подарки, показанные выше (подарки вне этого диапазона не будут учтены.)</br>2. Все подарки будут автоматически распределены среди топ-3 пользователей. Если вы выполнили условия и не получили подарки, пожалуйста, свяжитесь с нами.</br>3. Все значки этого мероприятия будут действовать в течение целого года.</br>4. Для победителя, пожалуйста, свяжитесь с нами для получения специального подарка.</br>5. Это мероприятие завершится 11 июля по времени KSA.</br>6. У приложения есть окончательное право на проведение этого мероприятия. Apple не является спонсором и не участвует в мероприятии в какой-либо форме.',
        content: 'Пришло время для праздника Ид аль-Адха. </br>Для празднования дня Ид аль-Адха, </br>редкие и уникальные медали будут вручены топ-3 пользователям.</br>Комнаты также получат подарки.</br>Будут учтены только следующие подарки:',
        mission: 'миссия',
        ranking: 'рейтинг',
        individual: 'индивидуальный',
        room: 'комната',
        rewards: 'награды',
        amount: 'Выполненное количество',
        collect: 'собрать',
        copyright: 'Авторские права на эту деятельность принадлежат приложению',
        collected: 'получено',
        specialgift: 'специальный фоновый подарок'

    },

    fa:{
        timeR: 'شمارش معکوس: ',
        ruleText: 'قوانین',
        DailyBenefits: 'مزایای روزانه',
        rule: '1. تنها هدایای نمایش داده شده در بالا جمع‌آوری خواهند شد (هر هدیه‌ای خارج از این محدوده شمرده نخواهد شد.)</br>2. تمامی هدایای به طور خودکار به 3 کاربر برتر توزیع خواهند شد. اگر شرایط را برآورده کرده‌اید و هدایا را دریافت نکرده‌اید، لطفاً با ما تماس بگیرید.</br>3. تمام نشان‌های این رویداد به مدت یک سال معتبر خواهند بود.</br>4. برای برنده‌ی برتر، لطفاً برای دریافت هدیه ویژه‌تان با ما تماس بگیرید.</br>5. این رویداد در تاریخ 11 ژوئیه به وقت KSA خاتمه خواهد یافت.</br>6. اپلیکیشن حق نهایی بر این فعالیت را دارد. اپل نه اسپانسر است و نه در این رویداد به هیچ شکلی شرکت دارد.',
        content: 'زمان عید قربان فرا رسیده است. </br>برای جشن گرفتن تاریخ عید قربان، </br>مدال‌های نادر و منحصر به فرد به 3 کاربر برتر اهدا خواهد شد.</br>اتاق‌ها نیز هدایایی دریافت خواهند کرد.</br>فقط هدایای زیر شمرده خواهند شد:',
        mission: 'ماموریت',
        ranking: 'رتبه‌بندی',
        individual: 'شخصی',
        room: 'اتاق',
        rewards: 'جوایز',
        amount: 'مقدار انجام شده',
        collect: 'جمع‌آوری',
        copyright: 'حق تکثیر این فعالیت متعلق به اپلیکیشن است',
        collected: 'دریافت شده',
        specialgift: 'هدیه پس‌زمینه ویژه'

    }
  }
  


// WEBPACK FOOTER //
// src/pages/activity/eidaladha/lang.js